export default "__VITE_ASSET___RxT20p1__"